import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-error-s",
  "use": "app-icon-error-s-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-error-s\"><path d=\"M8 1a6.98 6.98 0 00-7 7c0 3.882 3.118 7 7 7s7-3.118 7-7-3.118-7-7-7zm.445 10.627a.615.615 0 01-.89 0 .615.615 0 010-.89.615.615 0 01.89 0 .615.615 0 010 .89zm.191-2.99c0 .381-.254.636-.636.636s-.636-.255-.636-.637V4.818c0-.382.254-.636.636-.636s.636.254.636.636v3.818z\" fill=\"#C63939\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol